module.exports = __webpack_public_path__ + "static/submit_btn-a454b3626e80b6a276d30e3220c6b6bd.png";